<template>
  <v-combobox
    :data-testid="dataTestid"
    v-bind="$attrs"
    v-on="$listeners"
    :items="gouvernances"
  />
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      gouvernances: [
        { header: "Sélectionner une valeur, ou saisissez une valeur autre" },
        "Président",
        "Comité",
      ],
    };
  },
};
</script>
